import UserProfileAvatar from './UserProfileAvatar';
import inject from './inject';

export type { UserProfileAvatarProps } from './UserProfileAvatar';

export default inject(UserProfileAvatar);
